<template>
  <div 
  v-loading="loading" 
  :element-loading-text="$t('tips.loading') + '...'" 
  element-loading-spinner="el-icon-loading" 
  element-loading-background="#2a2d365e"
  >
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
  
</script>


<style lang="scss" >
.el-loading-mask {
  background-color: hsla(0,0%,100%,.3);
}

.custom-class .el-loading-spinner {
  color: #56d7f4;  
  background: url('~@/assets/common/气泡加载.svg');

}
.custom-class .el-loading-spinner::after {
  content: "jiazai";
  color: #56d7f4;
}
</style>



// WEBPACK FOOTER //
// src/components/common/baseLoading.vue